import Proxy from '../Proxy';

class StockVendorProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('stock-vendors', parameters);
  }
}

export default StockVendorProxy;
